import type { ViewConfig } from '@epc/contracts';
import { FileSpreadsheet, FileText } from 'lucide-react';
import { useState } from 'react';
import { Button } from '../../ui/button';
import { toast } from '../../ui/feedback';
import { downloadFromApi } from './util';

/** Выгрузка выборки в Excel (итоги формулами) и PDF (АН-10): то, что на экране, без суммы без права на деньги */
export function ExportButtons({
  source,
  config,
  asOf,
  title,
}: {
  source: string;
  config: ViewConfig;
  asOf?: string;
  title?: string;
}) {
  const [busy, setBusy] = useState<'xlsx' | 'pdf' | null>(null);
  const run = async (format: 'xlsx' | 'pdf') => {
    setBusy(format);
    try {
      await downloadFromApi('/reports/export', {
        body: { source, config, format, asOf: asOf || undefined, title: title || undefined },
        fallbackName: `${title || source}.${format}`,
      });
    } catch (e) {
      toast((e as Error).message, 'danger');
    } finally {
      setBusy(null);
    }
  };
  return (
    <>
      <Button
        size="sm"
        icon={<FileSpreadsheet className="size-4" />}
        loading={busy === 'xlsx'}
        onClick={() => run('xlsx')}
      >
        Excel
      </Button>
      <Button
        size="sm"
        icon={<FileText className="size-4" />}
        loading={busy === 'pdf'}
        onClick={() => run('pdf')}
      >
        PDF
      </Button>
    </>
  );
}
